import { css } from '@compiled/react';
import React, { forwardRef } from 'react';
import { token } from '@atlaskit/tokens';

// This button will take any HTML button props
const unstyledButtonStyles = css({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  background: 'none',
  color: 'inherit',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  fontFamily: token('font.family.brand.body'),
});

type UnstyledButtonProps = Omit<React.ComponentProps<'button'>, 'css'>;

/**
 * A button that removes all default styles.
 * Use the `style` prop to add custom styles.
 */
export const UnstyledButton = forwardRef<
  HTMLButtonElement,
  UnstyledButtonProps
>((props, ref) => {
  return (
    <button ref={ref} css={unstyledButtonStyles} {...props}>
      {props.children}
    </button>
  );
});

UnstyledButton.displayName = 'UnstyledButton';
